var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3902 21.3333H2.72355V2.66667H21.3902M21.3902 0H2.72355C1.25688 0 0.0568848 1.2 0.0568848 2.66667V21.3333C0.0568848 22.8 1.25688 24 2.72355 24H21.3902C22.8569 24 24.0569 22.8 24.0569 21.3333V2.66667C24.0569 1.18667 22.8569 0 21.3902 0ZM18.0569 17.6667C18.0569 15.6667 14.0569 14.6667 12.0569 14.6667C10.0569 14.6667 6.05688 15.6667 6.05688 17.6667V18.6667H18.0569M12.0569 12.3333C13.7102 12.3333 15.0569 10.9867 15.0569 9.33333C15.0569 7.68 13.7102 6.33333 12.0569 6.33333C10.4036 6.33333 9.05688 7.68 9.05688 9.33333C9.05688 10.9867 10.4036 12.3333 12.0569 12.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.4b28d51aa4de2673a1827faaee8de52c.svg";
export { ForwardRef as ReactComponent };